import React, { Component } from 'react'
import FixedView from '../FixedView'
import IntractionActionsList from '../IntractionActionsList'
import importedIcons from '../inputs/icons';

export default class TableHeadOptions extends Component {

    state = {}

    componentDidMount() {
        setTimeout(() => {
            this.setState({ show: true })
        }, 10);
    }

    opensize = (e) => {
        // e.preventDefault()
        // e.stopPropagation()
        if (this.fiexView) {
            this.fiexView.showView()
        }
    }

    deleteField = (data) => {
        this.props.deleteHeaderField(this.props.header)
        this.fiexView.hideView()
    }

    hideField = (data) => {
        this.props.hideHeaderField(this.props.header)
        this.fiexView.hideView()
    }
    
    groupByField = () => {
        // console.log('this.props.header',this.props.header)
        this.props.groupByField(this.props.header)
        this.fiexView.hideView()
    }

    editField = (data) => {
        this.props.fieldOptions(this.props.header)
        this.fiexView.hideView()
    }
    duplicateField = (type) => {
        this.props.duplicateField(this.props.header, type)
        this.fiexView.hideView()
    }
    insertField = (type) => {
        this.props.insertField(this.props.header, type)
        this.fiexView.hideView()
    }
    functionsHandler = (type, name, data) => {
        this.props.setCurrentHead(this.props.header)
        this.props.functionsHandler(type, name, data)
        this.fiexView.hideView()
    }

    sort = (type) => {
        this.props.sortFieldRecord(this.props.header, type)
    }

    render() {
        return (
            <div >
                <button className='p-0 br-5' onClick={() => this.opensize()} ref={el => this.fiexViewNode = el}>
                    <div className='table-header-option-but flexcc'>
                        <img className='flexcc' style={{}} width={18} height={18} src='/assets/icons/arrow-bottom-gray.svg' />
                    </div>
                </button>
                <FixedView ref={el => this.fiexView = el} width={260} nodeRef={this.fiexViewNode} showFocus={false} topOffset={2} xOffset={220} zIndex={10}>
                    <div className=' shadow-2 br-10 p-1' style={{ backgroundColor: "#fff", }}>
                        <div className='sc-1 p-1 sc-gray2' style={{ maxHeight: '320px', overflowY: 'auto', }}>
                            <div className='mb-2'>
                                <IntractionActionsList
                                    onClick={this.editField}
                                    // onClick={() => this.functionsHandler('collectionView', 'openAddCustomField', this.props.header)}
                                    data={{ title: "{{lang}}Edit field", icon: importedIcons.edit }} />
                            </div>
                            <div className='py-2' style={{ borderTop: '1px solid #eee' }}>
                                <IntractionActionsList onClick={() => this.duplicateField('duplicate')} data={{ title: "{{lang}}Duplicate field", icon: importedIcons.duplicate }} />
                                <IntractionActionsList onClick={() => this.insertField('left')} data={{ title: "{{lang}}Insert left", icon: importedIcons.insertLeft}} />
                                <IntractionActionsList onClick={() => this.insertField('right')} data={{ title: "{{lang}}Insert right", icon: importedIcons.insertRight}} />
                            </div>
                            <div className='py-2' style={{ borderTop: '1px solid #eee' }}>
                                {/* <IntractionActionsList data={{ title: "{{lang}}Copy field URL", icon: importedIcons.copyFieldUrl }} /> */}
                                {/* <IntractionActionsList data={{ title: "{{lang}}Edit field description", icon: "/assets/icons/note/trash-note.svg" }} /> */}
                                <IntractionActionsList data={{ title: "{{lang}}Edit field permissions", icon: importedIcons.editFieldPermissions }} />
                            </div>
                            <div className='py-2' style={{ borderTop: '1px solid #eee' }}>
                                <IntractionActionsList onClick={() => this.sort('asc')} data={{ title: "{{lang}}Sort A to Z", icon: importedIcons.decreasingSort}} />
                                <IntractionActionsList onClick={() => this.sort('desc')} data={{ title: "{{lang}}Sort Z to A", icon: importedIcons.increasingSort}} />
                            </div>
                            <div className='py-2' style={{ borderTop: '1px solid #eee' }}>
                                <IntractionActionsList data={{ title: "{{lang}}Filter by this field", icon: importedIcons.filterField}} />
                                <IntractionActionsList onClick={this.groupByField} data={{ title: "{{lang}}Group by this field", icon: importedIcons.groupFiled}} />
                            </div>
                            <div className='pt-2' style={{ borderTop: '1px solid #eee' }}>
                                <IntractionActionsList onClick={this.hideField} data={{ title: "{{lang}}Hide field", icon: importedIcons.hideField}} />
                                <IntractionActionsList onClick={this.deleteField} data={{ title: "{{lang}}Delete field", icon: importedIcons.deleteField}} />
                            </div>
                        </div>
                    </div>
                </FixedView>
            </div>
        )
    }
}